import { all, fork } from 'redux-saga/effects';
import { combineReducers } from 'redux';
import { PersistPartial } from 'redux-persist/es/persistReducer';

import * as auth from './ducks/auth.duck';
import * as users from './ducks/users.duck';
import * as profile from './ducks/profile.duck';
import * as companies from './ducks/companies.duck';
import * as promocodes from './ducks/promocodes.duck';

import * as categories from './ducks/categories.duck';
import * as products from './ducks/product.duck';
import * as productForDays from './ducks/product-for-days.duck';
import * as productTypes from './ducks/productType.duck';
import * as orders from './ducks/orders.duck';
import * as delivery from './ducks/delivery.duck';
import * as agreement from './ducks/agreement.duck';
import * as yaLocations from './ducks/yaLocations.duck';
import * as stores from './ducks/store.duck';
import * as cart from './ducks/cart.duck';
import * as supply from './ducks/supply.duck';
import * as blog from './ducks/blog.duck';
import * as productsCatalog from './ducks/product-catalog.duck';
import * as chat from './ducks/chat.duck';
import * as stat from './ducks/statistics.duck';
import * as transactions from './ducks/transactions.duck';
import * as banners from './ducks/banners.duck';

import { metronic } from '../../_metronic';

export type TAppActions =
  | auth.TActions
  | companies.TActions
  | promocodes.TActions
  | users.TActions
  | profile.TActions
  | categories.TActions
  | products.TActions
  | productForDays.TActions
  | productTypes.TActions
  | orders.TActions
  | delivery.TActions
  | agreement.TActions
  | yaLocations.TActions
  | stores.TActions
  | cart.TActions
  | blog.TActions
  | productsCatalog.TActions
  | supply.TActions
  | chat.TActions
  | stat.TActions
  | transactions.TActions
  | banners.TActions;

export interface IAppState {
  i18n: typeof metronic.i18n.reducer;
  builder: typeof metronic.builder.initialState;
  auth: auth.IInitialState & PersistPartial;
  companies: companies.IInitialState & PersistPartial;
  promocodes: promocodes.IInitialState & PersistPartial;
  banners: banners.IInitialState & PersistPartial;
  users: users.IInitialState & PersistPartial;
  profile: profile.IInitialState & PersistPartial;
  categories: categories.IInitialState & PersistPartial;
  products: products.IInitialState & PersistPartial;
  productForDays: productForDays.IInitialState & PersistPartial;
  productTypes: productTypes.IInitialState & PersistPartial;
  orders: orders.IInitialState & PersistPartial;
  delivery: delivery.IInitialState & PersistPartial;
  agreement: agreement.IInitialState;
  yaLocations: yaLocations.IInitialState;
  stores: stores.IInitialState & PersistPartial;
  cart: cart.IInitialState & PersistPartial;
  supply: supply.IInitialState & PersistPartial;
  blog: blog.IInitialState & PersistPartial;
  productsCatalog: productsCatalog.IInitialState & PersistPartial;
  chat: chat.IInitialState & PersistPartial;
  stat: stat.IInitialState & PersistPartial;
  transactions: transactions.IInitialState & PersistPartial;
}

export const rootReducer: (state: IAppState, action: TAppActions) => IAppState =
  combineReducers<IAppState, TAppActions>({
    auth: auth.reducer,
    companies: companies.reducer,
    promocodes: promocodes.reducer,
    banners: banners.reducer,
    users: users.reducer,
    profile: profile.reducer,
    i18n: metronic.i18n.reducer,
    builder: metronic.builder.reducer,
    categories: categories.reducer,
    products: products.reducer,
    productForDays: productForDays.reducer,
    productTypes: productTypes.reducer,
    orders: orders.reducer,
    delivery: delivery.reducer,
    agreement: agreement.reducer,
    yaLocations: yaLocations.reducer,
    stores: stores.reducer,
    cart: cart.reducer,
    blog: blog.reducer,
    productsCatalog: productsCatalog.reducer,
    supply: supply.reducer,
    chat: chat.reducer,
    stat: stat.reducer,
    transactions: transactions.reducer,
  });

export function* rootSaga() {
  yield all(
    [
      auth.saga,
      companies.saga,
      promocodes.saga,
      users.saga,
      profile.saga,
      categories.saga,
      stores.saga,
      products.saga,
      banners.saga,
      productForDays.saga,
      productTypes.saga,
      orders.saga,
      delivery.saga,
      agreement.saga,
      yaLocations.saga,
      cart.saga,
      blog.saga,
      productsCatalog.saga,
      supply.saga,
      chat.saga,
      stat.saga,
      transactions.saga,
    ].map(saga => fork(saga))
  );
}
